import React, { useContext, useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import {  Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import { IconButton } from "@mui/material";
import { Groups, SaveAlt, SmartToy as SmartToyIcon } from "@mui/icons-material";

import CallIcon from "@material-ui/icons/Call";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import MessageIcon from "@material-ui/icons/Message";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import TimerIcon from "@material-ui/icons/Timer";
import * as XLSX from "xlsx";
import CheckCircleOutlineIcon from "@material-ui/icons/RecordVoiceOver";
import ErrorOutlineIcon from "@material-ui/icons/RecordVoiceOver";

import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import TabPanel from "../../components/TabPanel";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import api from "../../services/api";
import { ChatsUser } from "./ChartsUser";

import Filters from "./Filters";
import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  LinearProgress,
  Box,
} from "@mui/material";
import { i18n } from "../../translate/i18n";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ForbiddenPage from "../../components/ForbiddenPage";
import Reports from "../Reports";
import ChatMoments from "../Moments";
import FlowBuilder from "../FlowBuilder";
import Kanban from "../Kanban";
import RelatorioVendas from "../RelatorioVendas";
import { ArrowDownward, ArrowUpward, DashboardOutlined, Description, GridOn, Cached, TrendingUp } from "@material-ui/icons";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import ViewKanban from "@mui/icons-material/ViewKanban";

const useStyles = makeStyles((theme) => ({
  overline: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
    letterSpacing: "0.5px",
    lineHeight: 2.5,
    textTransform: "uppercase",
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
  },
  h4: {
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
    fontWeight: 500,
    fontSize: "2rem",
    lineHeight: 1,
    color: theme.palette.text.primary,
  },
  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },
    "&:hover": {
      backgroundColor: "rgba(6, 81, 131, 0.3)",
    },
    "&$selected": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabIndicator: {
    borderWidth: "2px",
    borderStyle: "solid",
    height: 6,
    bottom: 0,
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.primary.contrastText,
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  nps: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.palette.primary.main,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  mainPaper: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    backgroundColor: "transparent !important",
    borderRadius: "10px",
  },
  paper: {
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  barContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  progressBar: {
    flex: 1,
    marginRight: theme.spacing(1),
    borderRadius: 5,
    height: 10,
  },
  progressLabel: {
    minWidth: 50,
    textAlign: "right",
    fontWeight: 500,
    color: theme.palette.mode === "light" ? theme.palette.text.secondary : theme.palette.text.primary,
  },
  infoCard: {
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: 12,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
  },
  infoIcon: {
    fontSize: "2rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  tabsScrollContainer: {
    display: "flex",
    justifyContent: "center",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    // No mobile, justify-content: center bloqueia scroll à esquerda — fix:
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
      paddingLeft: 4,
    },
  },
}));

const Dashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("Indicadores");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);

  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let nowIni = `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;

  let now = `${year}-${month < 10 ? `0${month}` : `${month}`
    }-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(nowIni);
  const [dateEndTicket, setDateEndTicket] = useState(now);
  const [queueTicket, setQueueTicket] = useState(false);
  const [fetchDataFilter, setFetchDataFilter] = useState(false);
  const [agentStats, setAgentStats] = useState(null);

  const { user } = useContext(AuthContext);

  // Tabs: estado local para troca instantânea, URL sincronizada para deep-link
  const location = useLocation();
  const history = useHistory();

  // Inicializa do URL (deep-link) mas controla localmente para evitar tela branca
  const [activeTab, setActiveTab] = useState(
    () => new URLSearchParams(location.search).get("tab") || "dashboard"
  );

  const handleTabChange = (_, newTab) => {
    setActiveTab(newTab);
  };

  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("grid-attendants")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendentes");
    XLSX.writeFile(wb, "relatorio-de-atendentes.xlsx");
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    let isMounted = true;
    
    async function firstLoad() {
      if (isMounted) {
        console.log('Executando firstLoad...');
        await fetchData();
      }
    }
    
    const timeoutId = setTimeout(() => {
      firstLoad();
    }, 500);
    
    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataFilter]);

  // Carregar stats de agentes IA (silencioso - não bloqueia o dashboard)
  useEffect(() => {
    api.get("/agents/company-stats")
      .then(({ data }) => setAgentStats(data))
      .catch(() => {});
  }, []);

  async function fetchData() {
    setLoading(true);
    console.log('Iniciando fetchData...');
  
    let params = {};
  
    // Construir parâmetros de filtro
    if (period > 0) {
      params = {
        days: period,
      };
      console.log('Usando filtro por dias:', period);
    } else {
      // Se não há período específico, usar as datas
      if (!isEmpty(dateStartTicket) && moment(dateStartTicket).isValid()) {
        params = {
          ...params,
          date_from: moment(dateStartTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de início:', dateStartTicket);
      }
  
      if (!isEmpty(dateEndTicket) && moment(dateEndTicket).isValid()) {
        params = {
          ...params,
          date_to: moment(dateEndTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de fim:', dateEndTicket);
      }
    }
  
    // Se nenhum parâmetro foi definido, usar período padrão de 30 dias
    if (Object.keys(params).length === 0) {
      console.log('Nenhum filtro definido, usando 30 dias como padrão');
      params = { days: 30 };
    }
  
    console.log('Parâmetros finais para busca:', params);
  
    try {
      const data = await find(params);
      console.log('Dados recebidos no componente:', data);
  
      // Garantir que counters sempre tenha valores válidos
      const safeCounters = data.counters || {};
      
      // Verificar especificamente o campo tickets
      console.log('Campo tickets recebido:', safeCounters.tickets);
      
      setCounters(safeCounters);
      
      if (isArray(data.attendants)) {
        setAttendants(data.attendants);
      } else {
        console.warn('Attendants não é um array:', data.attendants);
        setAttendants([]);
      }
  
      console.log('Estado atualizado - Counters:', safeCounters);
      console.log('Estado atualizado - Attendants:', data.attendants);
      
      // Log específico para verificar se o campo tickets está presente
      console.log('Valor de tickets no estado:', safeCounters.tickets);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      toast.error('Erro ao carregar dados do dashboard');
      
      // Definir valores padrão em caso de erro
      setCounters({
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportFinished: 0,
        supportHappening: 0,
        supportPending: 0,
        supportGroups: 0,
        leads: 0,
        activeTickets: 0,
        passiveTickets: 0,
        tickets: 0,
        waitRating: 0,
        withoutRating: 0,
        withRating: 0,
        percRating: 0,
        npsPromotersPerc: 0,
        npsPassivePerc: 0,
        npsDetractorsPerc: 0,
        npsScore: 0
      });
      setAttendants([]);
    } finally {
      setLoading(false);
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  function formatTime(minutes) {
    return moment().startOf("day").add(minutes, "minutes").format("HH[h] mm[m]");
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach((user) => {
      if (user.online === true) {
        userOnline = userOnline + 1;
      }
    });
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true,
        };
      } else {
        props = {
          fromMe: false,
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  // Mapa de título/subtítulo por tab
  const tabInfo = {
    dashboard: { title: "Dashboard",                subtitle: "Visão geral do atendimento" },
    reports:   { title: "Relatórios de Atendimentos", subtitle: "Análise detalhada dos atendimentos" },
    moments:   { title: "Painel em Tempo Real",      subtitle: "Monitoramento ao vivo" },
    bot:       { title: "Fluxos de Conversa",        subtitle: "Gerencie seus fluxos e automações" },
    crm:       { title: "CRM",                       subtitle: "Gestão de relacionamento com clientes" },
    vendas:    { title: "Relatório de Vendas",        subtitle: "Análise de vendas e conversões" },
  };
  const currentInfo = tabInfo[activeTab] || tabInfo.dashboard;

  // Cálculos para badges dinâmicos dos cards
  const totalActive = (counters.supportFinished || 0) + (counters.supportHappening || 0) + (counters.supportPending || 0);
  const finishedPerc = totalActive > 0 ? Math.round((counters.supportFinished || 0) / totalActive * 100) : 0;

  // Header + tabs estilo Atendechat
  const tabBar = (
    <Box
      style={{
        backgroundColor: theme.palette.background.default,
        flexShrink: 0,
      }}
    >
      {/* Linha do título */}
      <Box
        style={{
          padding: "16px 20px 4px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Typography
            style={{
              fontWeight: 700,
              fontSize: "1.25rem",
              lineHeight: 1.3,
              color: theme.palette.text.primary,
            }}
          >
            {currentInfo.title}
          </Typography>
          <Typography
            variant="body2"
            style={{
              color: theme.palette.text.secondary,
              marginTop: 2,
              fontSize: "0.8rem",
            }}
          >
            {currentInfo.subtitle}
          </Typography>
        </div>
        <Button
          startIcon={<Cached style={{ fontSize: 15 }} />}
          onClick={() => setFetchDataFilter((prev) => !prev)}
          size="small"
          style={{
            textTransform: "none",
            color: theme.palette.text.secondary,
            fontWeight: 500,
            fontSize: "0.8rem",
            marginTop: 4,
            padding: "4px 10px",
          }}
        >
          Atualizar
        </Button>
      </Box>

      {/* Linha das tabs — segmented control iOS style */}
      <Box className={classes.tabsScrollContainer} style={{ paddingBottom: 10, paddingTop: 2 }}>
        <Box style={{
          backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.07)" : "#eef0f3",
          borderRadius: 10,
          padding: "4px",
          display: "inline-flex",
          alignItems: "center",
          flexShrink: 0,
          maxWidth: "calc(100vw - 32px)",
          overflow: "hidden",
        }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{ style: { display: "none" } }}
            style={{ minHeight: 34 }}
          >
            {[
              { value: "dashboard", label: "Dashboard",  icon: <DashboardOutlined style={{ fontSize: 14 }} /> },
              { value: "reports",   label: "Relatórios", icon: <Description style={{ fontSize: 14 }} /> },
              { value: "moments",   label: "Painel",     icon: <GridOn style={{ fontSize: 14 }} /> },
              { value: "bot",       label: "Bot",        icon: <AccountTreeOutlinedIcon style={{ fontSize: 14 }} /> },
              { value: "crm",       label: "CRM",        icon: <ViewKanban style={{ fontSize: 14 }} /> },
              { value: "vendas",    label: "Vendas",     icon: <TrendingUp style={{ fontSize: 14 }} /> },
            ].map((t) => (
              <Tab
                key={t.value}
                label={t.label}
                value={t.value}
                icon={t.icon}
                iconPosition="start"
                style={{
                  minHeight: 32,
                  maxHeight: 32,
                  borderRadius: 7,
                  textTransform: "none",
                  fontWeight: activeTab === t.value ? 600 : 400,
                  fontSize: "0.84rem",
                  padding: "0 14px",
                  marginRight: 0,
                  color: activeTab === t.value
                    ? (theme.palette.type === "dark" ? "#fff" : theme.palette.primary.main)
                    : (theme.palette.type === "dark" ? "rgba(255,255,255,0.5)" : "#6b7280"),
                  backgroundColor: activeTab === t.value
                    ? (theme.palette.type === "dark" ? "rgba(255,255,255,0.15)" : `${theme.palette.primary.main}1A`)
                    : "transparent",
                  border: "none",
                  boxShadow: "none",
                  transition: "all 0.18s ease",
                }}
              />
            ))}
          </Tabs>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      {tabBar}

      {/* Aba Relatórios — sempre montada, oculta quando inativa */}
      <div style={{ flex: 1, overflow: "auto", display: activeTab === "reports" ? "block" : "none" }}>
        <Reports embedded={true} />
      </div>

      {/* Aba Painel — sempre montada, oculta quando inativa */}
      <div style={{ flex: 1, overflow: "auto", display: activeTab === "moments" ? "block" : "none" }}>
        <ChatMoments embedded={true} />
      </div>

      {/* Aba Bot (FlowBuilder) — sempre montada, oculta quando inativa */}
      <div style={{ flex: 1, overflow: "auto", display: activeTab === "bot" ? "block" : "none" }}>
        <FlowBuilder embedded={true} />
      </div>

      {/* Aba CRM (Kanban) — sempre montada, oculta quando inativa */}
      <div style={{ flex: 1, overflow: "auto", display: activeTab === "crm" ? "block" : "none" }}>
        <Kanban embedded={true} />
      </div>

      {/* Aba Relatório de Vendas */}
      <div style={{ flex: 1, overflow: "auto", display: activeTab === "vendas" ? "block" : "none" }}>
        <RelatorioVendas embedded={true} />
      </div>

      {/* Aba Dashboard — sempre montada, oculta quando inativa */}
      <div style={{ flex: 1, overflow: "auto", display: activeTab === "dashboard" ? "block" : "none" }}>
        {user.profile === "user" && user.showDashboard === "disabled" ? (
          <ForbiddenPage />
        ) : (
          <MainContainer>
            <Paper
              className={classes.mainPaper}
              elevation={0}
            >
            <Container maxWidth={false} className={classes.container} style={{ padding: '16px 8px', maxWidth: '100%', overflowX: 'hidden' }}>
              <Grid2 container spacing={2} className={classes.container} style={{ margin: 0, width: '100%' }}>
                {/* FILTROS */}
                <Grid2 xs={12} container justifyContent="flex-end">
                  <Button
                    onClick={toggleShowFilter}
                    color="primary"
                    startIcon={!showFilter ? <FilterListIcon /> : <ClearIcon />}
                  >
                    {showFilter ? "Ocultar Filtros" : "Mostrar Filtros"}
                  </Button>
                </Grid2>

                {showFilter && (
                  <Grid2 item xs={12} style={{ marginBottom: "20px" }}>
                    <Filters
                      classes={classes}
                      setDateStartTicket={setDateStartTicket}
                      setDateEndTicket={setDateEndTicket}
                      dateStartTicket={dateStartTicket}
                      dateEndTicket={dateEndTicket}
                      setQueueTicket={setQueueTicket}
                      queueTicket={queueTicket}
                      fetchData={setFetchDataFilter}
                    />
                  </Grid2>
                )}
                
                {[
                  { label: "Em Atendimento", value: counters.supportHappening || 0, icon: <WhatsAppIcon />, iconColor: "#25D366",
                    badge: (counters.supportHappening || 0) > 0 ? { text: "Ativos agora", color: "#2EA85A" } : null },
                  { label: "Aguardando", value: counters.supportPending || 0, icon: <HourglassEmptyIcon />, iconColor: "#47606e",
                    badge: (counters.supportPending || 0) > 5 ? { text: "Alta demanda", color: "#F79009" } : (counters.supportPending || 0) > 0 ? { text: "Na fila", color: "#47606e" } : null },
                  { label: "Finalizados", value: counters.supportFinished || 0, icon: <CheckCircleIcon />, iconColor: "#5852ab",
                    badge: finishedPerc > 0 ? { text: `${finishedPerc}% concluído`, color: "#5852ab" } : null },
                  { label: "Grupos", value: counters.supportGroups || 0, icon: <Groups />, iconColor: "#01BBAC",
                    badge: null },
                  { label: "Atendentes Ativos", value: `${GetUsers()}/${attendants.length}`, icon: <RecordVoiceOverIcon />, iconColor: "#805753",
                    badge: GetUsers() > 0 ? { text: "Online agora", color: "#2EA85A" } : { text: "Todos offline", color: "#999" } },
                  { label: "Novos Contatos", value: counters.leads || 0, icon: <GroupAddIcon />, iconColor: "#8c6b19",
                    badge: (counters.leads || 0) > 0 ? { text: "este período", color: "#8c6b19" } : null },
                  { label: "Mensagens Recebidas", value: `${GetMessages(false, false)}/${GetMessages(true, false)}`, icon: <MessageIcon />, iconColor: "#333133",
                    badge: null },
                  { label: "Mensagens Enviadas", value: `${GetMessages(false, true)}/${GetMessages(true, true)}`, icon: <SendIcon />, iconColor: "#558a59",
                    badge: null },
                  { label: "T.M. de Atendimento", value: formatTime(counters.avgSupportTime), icon: <AccessAlarmIcon />, iconColor: "#F79009",
                    badge: (counters.avgSupportTime || 0) > 60 ? { text: "Lento", color: "#EE4512" } : (counters.avgSupportTime || 0) > 0 ? { text: "Normal", color: "#2EA85A" } : null },
                  { label: "T.M. de Espera", value: formatTime(counters.avgWaitTime), icon: <TimerIcon />, iconColor: "#8a2c40",
                    badge: (counters.avgWaitTime || 0) > 30 ? { text: "Alto", color: "#EE4512" } : (counters.avgWaitTime || 0) > 0 ? { text: "Normal", color: "#2EA85A" } : null },
                  { label: "Tickets Ativos", value: counters.activeTickets || 0, icon: <ArrowUpward />, iconColor: "#EE4512",
                    badge: null },
                  { label: "Tickets Passivos", value: counters.passiveTickets || 0, icon: <ArrowDownward />, iconColor: "#28C037",
                    badge: null },
                ].map((indicator, index) => (
                  <Grid2 item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Paper style={{
                      borderRadius: 12,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                      padding: "20px 20px 16px",
                      position: "relative",
                      overflow: "hidden",
                      minHeight: 130,
                      backgroundColor: theme.palette.background.paper,
                      border: "1px solid #e5e7eb",
                    }}>
                      {/* Ícone flutuante no canto superior direito */}
                      <Box style={{
                        position: "absolute",
                        top: 16,
                        right: 16,
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundColor: `${indicator.iconColor}18`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        {React.cloneElement(indicator.icon, { style: { color: indicator.iconColor, fontSize: 22 } })}
                      </Box>
                      {/* Label */}
                      <Typography style={{
                        fontSize: 13,
                        color: theme.palette.type === "dark" ? "rgba(255,255,255,0.55)" : "#6b7280",
                        fontWeight: 400,
                        marginBottom: 8,
                        paddingRight: 52,
                        lineHeight: 1.3,
                      }}>
                        {indicator.label}
                      </Typography>
                      {/* Valor */}
                      <Typography style={{
                        fontSize: 32,
                        fontWeight: 600,
                        color: theme.palette.type === "dark" ? theme.palette.text.primary : "#1a1a1a",
                        lineHeight: 1.1,
                      }}>
                        {indicator.value}
                      </Typography>
                      {/* Badge dinâmico */}
                      {indicator.badge && (
                        <Box style={{ marginTop: 14 }}>
                          <span style={{
                            display: "inline-block",
                            padding: "3px 10px",
                            borderRadius: 20,
                            fontSize: 11,
                            fontWeight: 600,
                            color: indicator.badge.color,
                            backgroundColor: `${indicator.badge.color}18`,
                            letterSpacing: "0.2px",
                          }}>
                            {indicator.badge.text}
                          </span>
                        </Box>
                      )}
                    </Paper>
                  </Grid2>
                ))}

                {/* Pesquisa de Satisfação (NPS) */}
                <Grid2 item xs={12} style={{ marginTop: '40px' }}>
                  <Paper style={{
                    borderRadius: 16,
                    padding: '24px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    backgroundColor: theme.palette.background.paper,
                  }}>
                    <Typography style={{
                      fontSize: 13, fontWeight: 600, color: '#9ca3af',
                      textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: 20,
                    }}>
                      NPS — Net Promoter Score
                    </Typography>
                    <Box style={{ display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
                      {/* Score grande */}
                      <Box style={{ textAlign: 'center', minWidth: 80 }}>
                        <Typography style={{
                          fontSize: 56, fontWeight: 700, lineHeight: 1,
                          color: (counters.npsScore || 0) >= 70 ? '#10b981' : (counters.npsScore || 0) >= 50 ? '#f59e0b' : '#ef4444',
                        }}>
                          {counters.npsScore || 0}
                        </Typography>
                        <Typography style={{ fontSize: 10, color: '#9ca3af', fontWeight: 600, letterSpacing: '0.5px', marginTop: 4, textTransform: 'uppercase' }}>
                          Score
                        </Typography>
                      </Box>
                      {/* Pills + barra stacked */}
                      <Box style={{ flex: 1, minWidth: 200 }}>
                        <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
                          <span style={{ padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: '#d1fae5', color: '#065f46' }}>
                            Promotores {counters.npsPromotersPerc || 0}%
                          </span>
                          <span style={{ padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: '#fef3c7', color: '#92400e' }}>
                            Neutros {counters.npsPassivePerc || 0}%
                          </span>
                          <span style={{ padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: '#fee2e2', color: '#991b1b' }}>
                            Detratores {counters.npsDetractorsPerc || 0}%
                          </span>
                        </Box>
                        <Box style={{ display: 'flex', height: 8, borderRadius: 4, overflow: 'hidden', background: '#f3f4f6' }}>
                          <Box style={{ width: `${counters.npsPromotersPerc || 0}%`, background: '#10b981', transition: 'width 0.6s ease' }} />
                          <Box style={{ width: `${counters.npsPassivePerc || 0}%`, background: '#f59e0b', transition: 'width 0.6s ease' }} />
                          <Box style={{ width: `${counters.npsDetractorsPerc || 0}%`, background: '#ef4444', transition: 'width 0.6s ease' }} />
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Grid2>

                {/* Informações de Atendimento */}
                <Grid2 item xs={12} style={{ marginTop: '40px', paddingLeft: '4px' }}>
                  <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.primary.main }}>Atendimentos</Typography>
                </Grid2>
                {[
                  { label: "Total de Atendimentos", value: counters.tickets || 0, icon: <CallIcon />, iconColor: "#3b82f6" },
                  { label: "Aguardando avaliação", value: counters.waitRating || 0, icon: <HourglassEmptyIcon />, iconColor: "#f59e0b" },
                  { label: "Sem avaliação", value: counters.withoutRating || 0, icon: <ErrorOutlineIcon />, iconColor: "#ef4444" },
                  { label: "Avaliados", value: counters.withRating || 0, icon: <CheckCircleOutlineIcon />, iconColor: "#10b981" },
                ].map((attInfo, index) => (
                  <Grid2 item xs={12} sm={6} md={3} key={index}>
                    <Paper style={{
                      borderRadius: 12,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                      padding: "18px 18px 16px",
                      position: "relative",
                      overflow: "hidden",
                      backgroundColor: theme.palette.background.paper,
                      border: "1px solid #e5e7eb",
                      height: "100%",
                    }}>
                      <Box style={{
                        position: "absolute",
                        top: 14,
                        right: 14,
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        backgroundColor: `${attInfo.iconColor}18`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        {React.cloneElement(attInfo.icon, { style: { color: attInfo.iconColor, fontSize: 18 } })}
                      </Box>
                      <Typography style={{
                        fontSize: 13,
                        color: theme.palette.type === "dark" ? "rgba(255,255,255,0.55)" : "#6b7280",
                        fontWeight: 400,
                        marginBottom: 8,
                        paddingRight: 44,
                        lineHeight: 1.3,
                      }}>
                        {attInfo.label}
                      </Typography>
                      <Typography style={{
                        fontSize: 28,
                        fontWeight: 600,
                        color: theme.palette.type === "dark" ? theme.palette.text.primary : "#1a1a1a",
                        lineHeight: 1.1,
                      }}>
                        {attInfo.value}
                      </Typography>
                    </Paper>
                  </Grid2>
                ))}

                {/* Índice de Avaliação */}
                <Grid2 item xs={12} style={{ marginTop: '40px' }}>
                  <Paper style={{
                    borderRadius: 16,
                    padding: '24px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    backgroundColor: theme.palette.background.paper,
                  }}>
                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
                      <Box>
                        <Typography style={{
                          fontSize: 13, fontWeight: 600, color: '#9ca3af',
                          textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: 10,
                        }}>
                          Índice de Avaliação
                        </Typography>
                        <Typography style={{
                          fontSize: 44, fontWeight: 700, lineHeight: 1,
                          color: (counters.percRating || 0) >= 70 ? '#10b981' : (counters.percRating || 0) >= 50 ? '#f59e0b' : '#ef4444',
                        }}>
                          {(counters.percRating || 0).toFixed(1)}%
                        </Typography>
                        <Typography style={{ fontSize: 12, color: '#9ca3af', marginTop: 6 }}>
                          dos atendimentos foram avaliados
                        </Typography>
                      </Box>
                      {/* Gauge SVG circular */}
                      <svg width={96} height={96} viewBox="0 0 100 100">
                        <circle cx={50} cy={50} r={38} fill="none" stroke="#f3f4f6" strokeWidth={9} />
                        <circle
                          cx={50} cy={50} r={38} fill="none"
                          stroke={(counters.percRating || 0) >= 70 ? '#10b981' : (counters.percRating || 0) >= 50 ? '#f59e0b' : '#ef4444'}
                          strokeWidth={9}
                          strokeLinecap="round"
                          strokeDasharray={`${(2 * Math.PI * 38).toFixed(2)}`}
                          strokeDashoffset={`${(2 * Math.PI * 38 * (1 - (counters.percRating || 0) / 100)).toFixed(2)}`}
                          transform="rotate(-90 50 50)"
                          style={{ transition: 'stroke-dashoffset 0.6s ease' }}
                        />
                        <text x={50} y={54} textAnchor="middle" fontSize={14} fontWeight={700}
                          fill={(counters.percRating || 0) >= 70 ? '#10b981' : (counters.percRating || 0) >= 50 ? '#f59e0b' : '#ef4444'}>
                          {Math.round(counters.percRating || 0)}%
                        </text>
                      </svg>
                    </Box>
                    {/* Barra gradiente */}
                    <Box style={{ height: 6, borderRadius: 3, background: '#f3f4f6', marginTop: 20 }}>
                      <Box style={{
                        height: '100%', borderRadius: 3,
                        width: `${Math.min(counters.percRating || 0, 100)}%`,
                        background: (counters.percRating || 0) >= 70
                          ? 'linear-gradient(90deg, #6ee7b7, #10b981)'
                          : (counters.percRating || 0) >= 50
                          ? 'linear-gradient(90deg, #fcd34d, #f59e0b)'
                          : 'linear-gradient(90deg, #fca5a5, #ef4444)',
                        transition: 'width 0.6s ease',
                      }} />
                    </Box>
                  </Paper>
                </Grid2>

                {/* Atendentes */}
                <Grid2 item xs={12} style={{ marginTop: '40px' }}>
                  <Typography style={{
                    fontSize: 13, fontWeight: 600, color: '#9ca3af',
                    textTransform: 'uppercase', letterSpacing: '0.8px',
                    marginBottom: 16, paddingLeft: 4,
                  }}>
                    Atendentes
                  </Typography>
                  <TableAttendantsStatus
                    attendants={attendants}
                    loading={loading}
                  />
                </Grid2>

                {/* Card Desempenho dos Agentes IA */}
                {agentStats && agentStats.totalAgents > 0 && (
                  <Grid2 item xs={12} style={{ marginTop: "16px" }}>
                    <Paper style={{
                      borderRadius: 12,
                      padding: "16px 20px",
                      background: "linear-gradient(135deg, #faf5ff 0%, #f5f3ff 100%)",
                      border: "1px solid #e9d5ff",
                      boxShadow: "0 1px 3px rgba(124,58,237,0.08)",
                    }}>
                      <Box display="flex" alignItems="center" justifyContent="space-between" style={{ marginBottom: 12 }}>
                        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                          <SmartToyIcon style={{ color: "#7c3aed", fontSize: 20 }} />
                          <Typography style={{ fontWeight: 700, color: "#4c1d95", fontSize: "0.95rem" }}>
                            Desempenho dos Agentes IA
                          </Typography>
                        </Box>
                        <a href="/agents" style={{ fontSize: "0.75rem", color: "#7c3aed", fontWeight: 600, textDecoration: "none" }}>
                          Ver todos →
                        </a>
                      </Box>
                      <Grid2 container spacing={2}>
                        {[
                          { label: "Agentes Ativos", value: agentStats.totalAgents, color: "#7c3aed" },
                          { label: "Execuções Totais", value: agentStats.totalExecutions, color: "#6d28d9" },
                          { label: "Custo Acumulado", value: `$${(agentStats.totalCost || 0).toFixed(3)}`, color: "#5b21b6" },
                          { label: "Tool Mais Usada", value: agentStats.topTool ? agentStats.topTool.name.replace(/_/g, " ") : "—", color: "#4c1d95" },
                        ].map((item, idx) => (
                          <Grid2 item xs={6} sm={3} key={idx}>
                            <Box style={{ textAlign: "center" }}>
                              <Typography style={{ fontWeight: 800, fontSize: "1.3rem", color: item.color, lineHeight: 1.2 }}>
                                {item.value}
                              </Typography>
                              <Typography style={{ fontSize: "0.68rem", color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                {item.label}
                              </Typography>
                            </Box>
                          </Grid2>
                        ))}
                      </Grid2>
                    </Paper>
                  </Grid2>
                )}

                {/* Gráficos */}
                <Grid2 container spacing={3} item xs={12}>
                  <Grid2 item xs={12} md={6}>
                    <Paper className={classes.paper} style={{ marginBottom: "16px" }}>
                      <ChatsUser />
                    </Paper>
                  </Grid2>
                  <Grid2 item xs={12} md={6}>
                    <Paper className={classes.paper}>
                      <ChartsDate />
                    </Paper>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Container>
            </Paper>
          </MainContainer>
        )}
      </div>
    </div>
  );
};

export default Dashboard;